import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import { useTheme } from '@mui/system';

const userTestimonials = [
  {
    avatar: <Avatar alt="Robb Stark" src="/static/images/avatar/1.jpg" />,
    name: 'Robb Stark',
    occupation: 'Junior Kingdom Ruler',
    testimonial:
      "Wow, this is literally the best app I've ever used. I've used this against the Lannisters, marking them down as I went to Riverrun. Amazing...",
  },
  {
    avatar: <Avatar alt="Tyrion Lannister" src="/static/images/avatar/2.jpg" />,
    name: 'Tyrion Lannister',
    occupation: 'Medior Hand of the King',
    testimonial:
      "In it is in the interest of our realm that we use this product. I've found it to be an indispensable tool in navigating the complex political landscape of King's Landing. Its features have greatly aided me in my duties.",
  },
  {
    avatar: <Avatar alt="Catelyn Tully" src="/static/images/avatar/3.jpg" />,
    name: 'Catelyn Tully',
    occupation: 'Senior Advisor',
    testimonial:
      'This is like a journal to me. I keep photos of all my beautiful children, minus the bastard.',
  },
  {
    avatar: <Avatar alt="Robert Baratheon" src="/static/images/avatar/4.jpg" />,
    name: 'Robert Baratheon',
    occupation: 'Senior Army Commander',
    testimonial:
      "Gosh I was strong back then. Had all of my trophies marked into the application. Now look at me, a worn-out king. I use this app to relive my glory days.",
  },
  {
    avatar: <Avatar alt="Tywin Lannister" src="/static/images/avatar/5.jpg" />,
    name: 'Tywin Lannister',
    occupation: 'Chief Thrones Officer',
    testimonial:
      "What is the number one quality of a king? Power? Wealth? No. Wisdom. And IMPR to rule them all.",
  },
  {
    avatar: <Avatar alt="Ned Stark" src="/static/images/avatar/6.jpg" />,
    name: 'Ned Stark',
    occupation: 'Head of Northern Operations',
    testimonial:
      "Winter is coming, and so is IMPR. It is an honorable app. I use it to keep track of my family's legacy.",
  },
];

const whiteLogos = [
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560628e8573c43893fe0ace_Sydney-white.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f4d520d0517ae8e8ddf13_Bern-white.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f46794c159024c1af6d44_Montreal-white.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/61f12e891fa22f89efd7477a_TerraLight.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560a09d1f6337b1dfed14ab_colorado-white.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f5caa77bf7d69fb78792e_Ankara-white.svg',
];

const darkLogos = [
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560628889c3bdf1129952dc_Sydney-black.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f4d4d8b829a89976a419c_Bern-black.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f467502f091ccb929529d_Montreal-black.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/61f12e911fa22f2203d7514c_TerraDark.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560a0990f3717787fd49245_colorado-black.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f5ca4e548b0deb1041c33_Ankara-black.svg',
];

const logoStyle = {
  width: '64px',
  opacity: 0.3,
};

export default function Testimonials() {
  const theme = useTheme();
  const logos = theme.palette.mode === 'light' ? darkLogos : whiteLogos;

  return (
    <Container
      id="testimonials"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: { sm: 'left', md: 'center' },
        }}
      >
        <Typography
          component="h2"
          variant="h4"
          gutterBottom
          sx={{ color: 'text.primary' }}
        >
          Testimonials
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          See what our customers love about our products. Discover how we excel in
          efficiency, durability, and satisfaction. Join us for quality, innovation,
          and reliable support.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {userTestimonials.map((testimonial, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index} sx={{ display: 'flex' }}>
            <Card
              variant="outlined"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flexGrow: 1,
              }}
            >
              <CardContent>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ color: 'text.secondary' }}
                >
                  {testimonial.testimonial}
                </Typography>
              </CardContent>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <CardHeader
                  avatar={testimonial.avatar}
                  title={testimonial.name}
                  subheader={testimonial.occupation}
                />
                {/* <img
                  src={logos[index]}
                  alt={`Logo ${index + 1}`}
                  style={logoStyle}
                /> */}
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
